import PropTypes from 'prop-types';
import React from 'react';

import {ArchivedFilter} from '@utils/commonFilters/ArchivedFilter';
import {ClientsFilter} from '@utils/commonFilters/ClientsFilter';
import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

const ProductionCompanyFilters = ({
    data: {
        countries = [],
        clients = [],
    },
    loading,
    filters,
    restoreFilterValues,
}) => {
    return (
        <div className='productionCompanies__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={filters.productionCompanies}
                restoreFilterValues={restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={filters.productionCompanies}
                restoreFilterValues={restoreFilterValues}
            />
            <ClientsFilter
                loading={loading}
                filters={filters.productionCompanies}
                restoreFilterValues={restoreFilterValues}
                options={clients}
            />
            <ArchivedFilter
                loading={loading}
                filters={filters}
                filterKey='productionCompanies'
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

ProductionCompanyFilters.propTypes = {
    data: PropTypes.shape({
        countries: PropTypes.array,
        clients: PropTypes.array,
        isArchived: PropTypes.array,
    }),
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(ProductionCompanyFilters, {name: 'productionCompanies', initialValues: {isArchived: 0}});
